module.exports = __webpack_public_path__ + "static/media/shopify-icon.cac815e4.svg";